import { render, staticRenderFns } from "./ai_assistant.vue?vue&type=template&id=5b57027e&scoped=true&"
import script from "./ai_assistant.vue?vue&type=script&lang=js&"
export * from "./ai_assistant.vue?vue&type=script&lang=js&"
import style0 from "./ai_assistant.vue?vue&type=style&index=0&id=5b57027e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57027e",
  null
  
)

export default component.exports